import { NewOrdersContentContainer } from "components/NewOrders/NewOrders.styles";
import ViewPriceEstimatesContent from "components/NewOrders/ViewPriceEstimates/ViewPriceEstimatesContent";
import NewOrdersHeader from "components/NewOrders/NewOrdersHeader/NewOrdersHeader";
import { useSelector } from "react-redux";
import { RootState } from "stores/application.store";
import { PageProps } from "../BuildOrderPage/BuildOrderPage";

const ViewPriceEstimatesPage = ({ isAddOn, isCustomColor, isNewQuoteOrder }: PageProps) => {
	const draft = useSelector((state: RootState) => state.newOrder.draftDetails?.draftOrder);

	return (
		<div>
			<NewOrdersHeader
				isPDFExport
				draftOrder={draft}
				isAddOn={isAddOn}
			/>
			<NewOrdersContentContainer>
				<ViewPriceEstimatesContent
					isAddOn={isAddOn}
					isNewQuoteOrder={isNewQuoteOrder}
				/>
			</NewOrdersContentContainer>
		</div>
	);
};

export default ViewPriceEstimatesPage;
